export function createQuery(host, iface, type, durationStart = "-60m", durationEnd = "0m", durationInterval = "5m") {
  if (type === 'snmp') {
    return `
      incoming_bandwidth = from(bucket: "telegraf")
      |> range(start: ${durationStart}, stop: ${durationEnd})
      |> filter(fn: (r) => r["_measurement"] == "interface" and r["_field"] == "ifInOctets")
      |> filter(fn: (r) => r["agent_host"] == "${host}" and r["ifDescr"] == "${iface}")
      |> derivative(unit: 1s, nonNegative: true)
      |> aggregateWindow(every: ${durationInterval}, fn: mean, createEmpty: true)
      |> map(fn: (r) => ({
        _time: r._time,
        _field: "input_bps",
        _value: ((if r._value < 0.0 then -1.0 * float(v: r._value) else float(v: r._value)) * 8.0)
      }))

      outgoing_bandwidth = from(bucket: "telegraf")
      |> range(start: ${durationStart}, stop: ${durationEnd})
      |> filter(fn: (r) => r["_measurement"] == "interface" and r["_field"] == "ifOutOctets")
      |> filter(fn: (r) => r["agent_host"] == "${host}" and r["ifDescr"] == "${iface}")
      |> derivative(unit: 1s, nonNegative: true)
      |> aggregateWindow(every: ${durationInterval}, fn: mean, createEmpty: true)
      |> map(fn: (r) => ({
        _time: r._time,
        _field: "output_bps",
        _value: ((if r._value < 0.0 then -1.0 * float(v: r._value) else float(v: r._value)) * 8.0)
      }))

      union(tables: [incoming_bandwidth, outgoing_bandwidth])
      |> yield(name: "bwutil_bps")
    `;
  } else {
    // return `
    //   from(bucket: "telegraf")
    //   |> range(start: ${durationStart}, stop: ${durationEnd})
    //   |> filter(fn: (r) => r["_measurement"] == "ezelink_interface_rx" or r["_measurement"] == "ezelink_interface_tx")
    //   |> filter(fn: (r) => r["type"] == "if_octets")
    //   |> filter(fn: (r) => r["host"] == "${host}")
    //   |> filter(fn: (r) => r["instance"] == "${iface}")
    //   |> aggregateWindow(every: ${durationInterval}, fn: mean, createEmpty: true)
    //   |> derivative(unit: 1s, nonNegative: true) // <-- this line gives you bytes/sec
    //   |> map(fn: (r) => ({ r with _value: r._value * 8.0 }))
    //   |> yield(name: "mean")
    // `;
    return `
      from(bucket: "telegraf")
      |> range(start: ${durationStart}, stop: ${durationEnd})
      |> filter(fn: (r) => r["_measurement"] == "ezelink_interface_rx" or r["_measurement"] == "ezelink_interface_tx")
      |> filter(fn: (r) => r["type"] == "if_octets")
      |> filter(fn: (r) => r["host"] == "${host}")
      |> filter(fn: (r) => r["instance"] == "${iface}")
      |> aggregateWindow(every: ${durationInterval}, fn: max, createEmpty: true)
      |> derivative(unit: 1s, nonNegative: true) // <-- this line gives you bytes/sec
      |> map(fn: (r) => ({ r with _value: r._value * 8.0 }))
    `;
  }
}
